// Option.js
import React, { useState } from "react";
import QuantityControl from "./QuantityControl";
import SubOptionList from "./SubOptionList";
import "./FoodItem.css";

export default function Option({
  option,
  addonId,
  foodItemQuantity,
  optionButtonId,
  selectedOption,
  onRadioOptionToggle,
  onCheckboxOptionToggle,
  onOptionQuantityChange,
  onSubOptionChange,
}) {
  const isChecked = !!selectedOption?.enabled;
  const quantity = selectedOption?.quantity || 0;
  const [suppressOnChange, setSuppressOnChange] = useState(false);

  const optionQuantity = option.isCountableLinked ? foodItemQuantity : quantity;

  const handleInitialAdd = () => {
    setSuppressOnChange(true);
    if (optionButtonId === 3) {
      onRadioOptionToggle(addonId, option, true); // radio
    } else if (optionButtonId === 4) {
      onCheckboxOptionToggle(addonId, option, true); // checkbox
    }
  };

  const handleRadioChange = () => {
    if (!suppressOnChange) {
      if (isChecked) {
        onRadioOptionToggle(addonId, option, false); // deselect
      } else {
        onRadioOptionToggle(addonId, option, true); // select
      }
    }
  };

  const handleCheckboxChange = () => {
    if (!suppressOnChange) {
      onCheckboxOptionToggle(addonId, option);
    }
  };

  const handleInputClick = () => {
    // debugger
    setSuppressOnChange(false);
  };

  return (
    <div className='option'>
      <label className='d-flex justify-content-between align-items-center'>
        <div className='d-flex align-items-center'>
          {/* Separate input rendering */}
          {optionButtonId === 3 && (
            <input
              type='checkbox'
              checked={isChecked}
              onChange={handleRadioChange}
              onClick={handleInputClick}
              className='me-2 fake-radio'
            />
          )}
          {optionButtonId === 4 && (
            <input
              type='checkbox'
              checked={isChecked}
              onChange={handleCheckboxChange}
              onClick={handleInputClick}
              className='me-2'
            />
          )}

          <span>{option.optionName}</span>
          {isChecked && optionQuantity > 0 && (
            <span> (x{optionQuantity}) </span>
          )}
          {option.isMandatory && <span className='text-danger'> *</span>}
          {option.isCountableLinked && (
            <i
              className='fas fa-link ms-2 text-primary'
              title='Linked Option'
            ></i>
          )}
        </div>

        <div className='d-flex align-items-center gap-2'>
          {/* <span>${option.basePrice}</span> */}
          {isChecked ? (
            <span>
              $
              {(optionQuantity <= 0
                ? option.basePrice
                : option.basePrice * optionQuantity
              ).toFixed(2)}
            </span>
          ) : (
            <span>${option.basePrice}</span>
          )}

          {option.isCountable &&
            !option.isCountableLinked &&
            (isChecked ? (
              <QuantityControl
                value={quantity}
                onIncrease={() =>
                  onOptionQuantityChange(
                    addonId,
                    option,
                    +option.incrementalQuantity
                  )
                }
                onDecrease={() =>
                  onOptionQuantityChange(
                    addonId,
                    option,
                    -option.incrementalQuantity
                  )
                }
                minValue={option.minQuantity}
                maxValue={option.maxQuantity}
                hideTitle={true}
                type='addon'
              />
            ) : (
              <button
                onClick={handleInitialAdd}
                className='circle-btn addon-initial-btn'
              >
                +
              </button>
            ))}
        </div>
      </label>

      {option.subOptions?.length > 0 && isChecked && (
        <SubOptionList
          addonId={addonId}
          optionId={option.optionId}
          subOptions={option.subOptions}
          selectedSubOptions={selectedOption?.subOptions || {}}
          onSubOptionChange={onSubOptionChange}
          optionQuantity={optionQuantity}
        />
      )}
    </div>
  );
}
